(() => {
  async function copyText(text) {
    if (navigator.clipboard?.writeText) {
      try { await navigator.clipboard.writeText(text); return; } catch (_) { /* Fallback for restricted clipboard contexts. */ }
    }
    const previousFocus = document.activeElement;
    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.cssText = 'position:fixed;top:0;left:-9999px;opacity:0';
    document.body.append(input);
    input.select();
    const copied = document.execCommand('copy');
    input.remove();
    previousFocus?.focus({preventScroll:true});
    if (!copied) throw new Error('Clipboard unavailable');
  }
  let toast;
  let toastTimer;
  function showConfirmation(text) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'mr-bf-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.append(toast);
    }
    toast.textContent = `✓ Code copied: ${text}`;
    toast.dataset.visible = 'true';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.dataset.visible = 'false'; }, 3500);
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-mr-copy-code]');
    if (!button) return;
    event.preventDefault();
    const text = button.dataset.mrCopyCode;
    const status = button.querySelector('.mr-bf-copy__status');
    try {
      await copyText(text);
      status.textContent = 'copied';
      button.dataset.mrCopied = 'true';
      showConfirmation(text);
      button.setAttribute('aria-label', `Code ${text} copied`);
    } catch (_) {
      status.textContent = 'select';
      const range = document.createRange();
      range.selectNodeContents(button.querySelector('.mr-bf-copy__code'));
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      button.setAttribute('aria-label', `Select and copy code ${text}`);
    }
    clearTimeout(button.mrResetTimer);
    button.mrResetTimer = setTimeout(() => {
      if (!button.isConnected) return;
      status.textContent = 'copy';
      delete button.dataset.mrCopied;
      button.setAttribute('aria-label', `Copy code ${text}`);
    }, 3500);
  });
  // Shopify enforces the discount deadline. Also remove stale promotion messages in long-open tabs.
  function expireMessages() {
    const now = Date.now();
    document.querySelectorAll('[data-mr-bf-offer]').forEach(offer => {
      if (Date.parse(offer.dataset.expires) <= now) offer.hidden = true;
    });
  }
  expireMessages();
  document.addEventListener('visibilitychange', expireMessages);
  setInterval(expireMessages, 60000);
})();
